import PDFViewer from './dist/pdf-viewer-reactjs';

export default PDFViewer;
